<template>
  <div v-if="examine && examine.actions">
    <v-sheet class="pt-1 transparent-background-color d-inline-block">
      <v-tooltip
        top
        v-if="showExamine && $permission.permissionAllow('Examines', 'examine')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="primary"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('edit')
                  : $router.push('/examines/' + examine.id + '/edit');
              })
            "
          >
            {{ $t("Examine.actions.examine") }}
          </v-btn>
        </template>
        <span>{{ $t("Examine.actions.examine") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showAbnormal &&
          $permission.permissionAllow('Examines', 'abnormalEdit')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="accent"
            class="px-2 me-2 mb-1"
            :href="'/#/examines/abnormal/' + examine.id + '/edit'"
          >
            {{ $t("Examine.actions.exception_handling") }}
          </v-btn>
        </template>
        <span>{{ $t("Examine.actions.exception_handling") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="showView && $permission.permissionAllow('Examines', 'view')"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            @click.stop="
              $permission.checkAccountExpired().then(() => {
                detailMode
                  ? $emit('view')
                  : $router.push('/examines/' + examine.id);
              })
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Opt.details") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Examine.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showAbnormalDetail &&
          $permission.permissionAllow('Examines', 'viewByAbnormal')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/examines/abnormal/' + examine.id"
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Examine.actions.examine_abnormal_detail") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Examine.ObjectName")]) }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          showExamineImg &&
          $permission.permissionAllow('Examines', 'view')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            @click.stop="
              currentItem = examine;
              examineImgDialog = true;
            "
          >
            <v-icon x-small class="pe-1">fa-align-left</v-icon>
            {{ $t("Examine.actions.examine_img") }}
          </v-btn>
        </template>
        <span>{{ $t("CRUD.viewInfo", [$t("Examine.ExamineImg.title")]) }}</span>
      </v-tooltip>

      <v-tooltip
        top
        v-if="
          showExport &&
          $permission.permissionAllow('Examines', 'detailExport')
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="print"
            class="px-2 me-2 mb-1"
            @click.stop="examineExport()"
          >
            <v-icon x-small class="pe-1">fa-file-export</v-icon>
            {{ $t("Examine.actions.examine_detail_export") }}
          </v-btn>
        </template>
        <span>{{ $t("Examine.actions.examine_detail_export") }}</span>
      </v-tooltip>
      <v-tooltip
        top
        v-if="
          $permission.permissionAllow('ReturnOrders', 'add') &&
          examine.shop.psi_enable == 0
        "
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            small
            dark
            color="info"
            class="px-2 me-2 mb-1"
            :href="'/#/return-order-new?order_id=' + examine.order_id + '&order_code=' + examine.order_code + '&shop_id=' + examine.shop_id"
          >
            <v-icon x-small class="pe-1">fa-truck-loading</v-icon>
            {{ $t("ReturnOrderApply.Fields.apply") }}
          </v-btn>
        </template>
        <span>{{ $t("ReturnOrderApply.Fields.apply") }}</span>
      </v-tooltip>
    </v-sheet>
    <ExamineImgDialog
      v-model="examineImgDialog"
      :item="currentItem"
    />
  </div>
</template>

<script>
import Examines from "@/api/examines";
import ExamineImgDialog from "./ExamineImgDialog";

export default {
  name: "ExamineActions",

  components: {
    ExamineImgDialog
  },

  props: {
    examine: Object,
    detailMode: Boolean,
    showView: Boolean,
    showExamine: Boolean,
    showAbnormal: Boolean,
    showAbnormalDetail: Boolean,
    showExport: Boolean,
    showExamineImg: Boolean,
  },

  data: () => ({
    printBtnMenu: false,
    exportBtnMenu: false,
    editLogisticAlert: false,
    currentItem: null,
    examineImgDialog: false,
  }),
  methods: {
    examineExport() {
      Examines.detailExport(this.examine.id);
    },
  },
};
</script>